import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import {
  doubleTapRestorePersistedState,
  restorePersistedState, toggleProjectsCrudModal
} from "../../actions/project-crud-actions";
import {
  setCurrentProject
} from "../../actions/project-actions";
import {
  toggleProjectsAdminModal,
  toggleAdminProjectsLoader, showProjectsAdminMultibedWarning
} from "../../actions/projects-admin-action";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { Icon } from "office-ui-fabric-react/lib/Icon";
import Project from "../../lib/project";
import { loginUser, logoutUser } from "../../actions/authentication-actions";
import { Dialog, DialogFooter, DialogType, Dropdown } from "office-ui-fabric-react";
import { processingTypeColoring } from "../ProjectsCrud/project-detail-list-columns";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import {
  hideUnsavedChangesDialog,
  loadingMultiBedProject,
  setMultiBedOtherUserData,
  setSelectedBed
} from "../../actions/multi-bed-actions";
import "./ProjectsAdminCrud.css";
import _ from "lodash";
import { loadingBed, setDirtyStateForMultiBeds } from "../../actions/multi-bed-actions";
import SubProjectService from "../../lib/services/sub-project-service";
import { resetSystemParams } from "../../actions/system-parameters-actions";
import { setActiveLanguage, setActiveRegion } from "../../actions/localization-actions";
import { clearMainManifoldsState } from "../../actions/manifold-actions";
import { clearViewPort, setCurrentSubProject } from "../../actions/sub-project-actions";
import { restoreSubProjectPersistedState } from "../../actions/sub-project-crud-actions";
import ProjectService from "../../lib/services/project-service";
import MiniCADAPI_SEARCH from "../../lib/MiniCADAPI_SEARCH";
import { setProjectsUrlInvalidDialog, switchRefreshAdminProjects } from "../../actions/generic-globals.actions";
import { InputText } from "primereact/inputtext";
import dayjs from "dayjs";
import GeneralService from "../../lib/services/general-service";
import MultiBedService from "../../lib/services/multibed-service";
const { hasAdminAccess } = require("../LeftMenu/ProjectInfo/internalUsers");

class ProjectsDetailListComponent extends PureComponent{
  constructor( props ) {
    super(props);
    this.state = {
      selectionDetails: "",
      showItemIndexInView: false,
      isCompactMode: false,
      isModalSelection: true,
      hideDialog: true,
      confirmCB: null,
      projects: this.props.projects,
      modalProps: {
        titleAriaId: "myLabelId",
        subtitleAriaId: "mySubTextId",
        isBlocking: false,
        containerClassName: "ms-dialogMainOverride"
      },
      contentProps: {
        type: DialogType.normal,
        title: "Do you want to save the current project?",
        subText: "Your current project state will be saved"
      },
      tableColumns: [],
      selectedProject: null,
      selectedCount: 0,
      expandedRows: null,
      isLoading: false,

      selectedStatus: null,
      selectedType: null,
      globalFilter: ""
    };

    this.onRowSelectDoubleClick = this.onRowSelectDoubleClick.bind(this);
    this.expandAll = this.expandAll.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.styledHeader = this.styledHeader.bind(this);
    this.formatProcessingStatus = this.formatProcessingStatus.bind(this);
    this.formatBOOMFile = this.formatBOOMFile.bind(this);
    this.formatCSVFile = this.formatCSVFile.bind(this);
    this.formatStageStorageFileFile = this.formatStageStorageFileFile.bind(this);
    this.formatProcessingResult = this.formatProcessingResult.bind(this);
    this.formatTranslatedProjectType = this.formatTranslatedProjectType.bind(this);
    this.formatCreatedDate = this.formatCreatedDate.bind(this);
    this.formatEditedDate = this.formatEditedDate.bind(this);
    this.expanderButton = this.expanderButton.bind(this);


    this.onStatusChange = this.onStatusChange.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.reset = this.reset.bind(this);
    this.statusItemTemplate = this.statusItemTemplate.bind(this);

    this.statuses = [
      { key: null, text: this.props.content[this.props.lang].allStatuses },
      { key: 'success', text: this.props.content[this.props.lang].successStatus },
      { key: 'failed', text: this.props.content[this.props.lang].failedStatus },
      { key: 'unsubmitted', text: this.props.content[this.props.lang].unsubmitedStatus },
    ];
    this.types = [
      { key: null, text: "All types" },
      { key: "Chamber", text: "Chamber" },
      { key: "Pipe", text: "Pipe" }
    ];
  }

  componentWillReceiveProps( nextProps, nextContext ) {
    this.setState({
      projects: nextProps.projects
    });
  }

  async getSingleRecord( cuid ) {
    this.props.toggleAdminProjectsLoader(true);
    this.setState({
      isLoading: true,
      hideDialog: true
    });
    try {
      let project = new Project(cuid);
      await project
        .fetch(
          this.props.selectedUser.id,
          this.props.iTokens.projects["iTableToken"]
        );

      let state = await project
        .fetchState(
          this.props.selectedUser.id,
          this.props.iTokens.projects["iBlobToken"]
        );

      if (project.region && project.language) {
        this.props.resetSystemParams();

        // If this was created before we changed "United States of America" to "USA", update it here
        if (project.region === "United States of America")
          project.region = "USA";
        const projRegion = this.props.regions.find(r => r.name === project.region);
        this.props.setActiveRegion(projRegion.id);
        const projLang = this.props.languages.find(l => l.name === project.language);
        this.props.setActiveLanguage(projLang.id);
      }

      project.processingStatus = Project.PROCESSING_STATUS.copied;// Set the propper status
      this.props.setCurrentProject(project);
      this.props.clearMainManifoldsState();

      try {
        // prevents doing double load, by updating userModified
        let modManifolds = [];
        if (state.mainManifolds && state.mainManifolds.manifolds) {
          modManifolds = state.mainManifolds.manifolds
            .map(manifold => {
              manifold._userModified = true;
              return manifold;
            });
        }
        state.mainManifolds["manifolds"] = [...modManifolds];
      } catch (error) {
        console.info(`ProjectsDetailListComponent.getSingleRecord(), state.mainManifolds["manifolds"] :: ${error.message}`);
      }

      this.props.restorePersistedState(state);
      this.props.setMultiBedOtherUserData(this.props.selectedUser.id, this.props.iTokens);

      const pType = state.globals.projectType;
      setTimeout(() => {
        if (state.globals.projectType === "PIPE") {
          // dirty clone this object
          let secondStatePass = JSON.parse(JSON.stringify(state));
          // the background is the only one not serializable, assign again
          secondStatePass.background = state.background;
          this.props.doubleTapRestorePersistedState(secondStatePass);
        }
        // this.props.toggleProjectsCrudModal(false);
        this.props.toggleProjectsAdminModal(false);
        this.props.setDirtyStateForMultiBeds(false);
        this.props.toggleAdminProjectsLoader(false);

        this.setState({
          isLoading: false
        });
      }, 0);

      // Process multibed load, should load last bed on array
      if (project && project.isMultiBedProject) {

        this.props.loadingBed(true);
        this.props.loadingMultiBedProject(true);

        let beds = [];
        if (state["multiBed"] && state["multiBed"].beds)
          beds = state["multiBed"].beds;
        let lastId = 0;
        if (beds.length > 0)
          lastId = beds[beds.length - 1].id;

        SubProjectService
          .clearViewPortForMultiBed(this.props)
          .then(() => {

            let otherUser = {};

            otherUser["otherUserId"] = this.props.selectedUser.id;
            otherUser["otherUserTokens"] = this.props.iTokens;


            SubProjectService
              .loadSubProject(lastId, this.props, true, otherUser)
              .finally(() => {
                this.props.setDirtyStateForMultiBeds(false);
                this.props.loadingBed(false);
                this.props.loadingMultiBedProject(false);
              });
          });
        this.props.setSelectedBed(lastId);
        this.props.hideUnsavedChangesDialog();

        if (pType === "PIPE") {
          console.log("%c CARGADO 3 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< ", "color:yellow; background-color:red;");
          // const rs = await MultiBedService.syncBedsData(this.props.multiBedBeds, this.props);
        }

      }

      this.props.showProjectsAdminMultibedWarning(true);

    } catch (e) {
      this.setState({
        isLoading: false
      });
      console.error(`ProjectsDetailListComponent.getSingleRecord() :: ${e.message}`);
    }

  }

  handleFilterByName = ( e ) => {
    this.setState({
      projects: this.props.projects.filter(project =>
        project.projectName.toLowerCase().includes(e.target.value.toLowerCase()))
    });
  };

  closeDialog = () => {
    this.setState({
      hideDialog: true
    });

    this.setState({ selectedProject: null });
  };

  handleConfirm = () => {
    this.state.confirmCB();
  };

  onRowSelectDoubleClick( event ) {
    const { data: item } = event;
    this.setState({
      confirmCB: () => {
        this.getSingleRecord(item.id);
      },
      contentProps: {
        type: DialogType.normal,
        title: this.props.content[this.props.lang].loadMyProjectDialogMain.replace("{0}", item.projectName),
        subText: this.props.content[this.props.lang].loadProjectDialogSub
      },
      hideDialog: false
    });
  }

  styledHeader( data ) {
    return <span style={{
      display: "flex",
      alignItems: "flex-end",
      marginRight: "5px"
    }}><i className={`ms-Icon ms-Icon--${data.iconName}`} style={{ fontSize: "13px", marginRight: "5px" }} /> {data.fieldName}</span>;
  }

  expandAll() {
    let expandedRows = {};
    this.state.projects.forEach(p => expandedRows[`${p.id}`] = true);
    this.setState({
      expandedRows
    });
  }

  expandById( id, eve ) {
    let expandedRows = { ...this.state.expandedRows };
    if (expandedRows && expandedRows[id]) {
      delete expandedRows[id];
    } else {
      expandedRows[id] = true;
    }
    this.setState({
      expandedRows
    });
  }

  collapseAll() {
    let expandedRows = {};
    this.state.projects.forEach(p => expandedRows[`${p.id}`] = false);
    this.setState({
      expandedRows
    });
  }

  formatProcessingStatus( project ) {
    const { processingStatus: status } = project;
    return <span className={`status ${processingTypeColoring[status]}`}>{this.props.content[this.props.lang][status]}</span>;
  }

  formatBOOMFile( project ) {
    const { processingStatus: status, bomFileUrl, bomFileUrlPipe } = project;
    const validURL = GeneralService.isAzureUrlValid(
      bomFileUrl ? bomFileUrl : bomFileUrlPipe
    );

    const isInternalUser = true;
    if (status === Project.PROCESSING_STATUS.success && isInternalUser) {
      return <ul>
        {bomFileUrl ?
          validURL ?
            <li><a href={bomFileUrl}>{this.props.content[this.props.lang].downloadChamberBom}</a></li> :
            <li><a href="#" onClick={() => {
              this.props.setProjectsUrlInvalidDialog(true);
            }}>{this.props.content[this.props.lang].downloadChamberBom}</a></li>
          : <span />}
        {bomFileUrlPipe ?
          validURL ?
            <li><a href={bomFileUrlPipe}>{this.props.content[this.props.lang].downloadPipeBom}</a></li> :
            <li><a href="#" onClick={() => {
              this.props.setProjectsUrlInvalidDialog(true);
            }}>{this.props.content[this.props.lang].downloadPipeBom}</a></li>
          : <span />}
      </ul>;
    } else {
      return "N/A";
    }
  }

  formatCSVFile( project ) {
    const { processingStatus: status, csvFileUrl, csvFileUrlPipe } = project;
    const validURL = GeneralService.isAzureUrlValid(
      csvFileUrl ? csvFileUrl : csvFileUrlPipe
    );
    // STRY0177874: same allowlist as the admin button, so the CSV column is
    // visible to the admin domains instead of the old hardcoded domain list.
    const isInternalUser = hasAdminAccess(this.props.user && this.props.user.mail);

    if (status === Project.PROCESSING_STATUS.success && isInternalUser) {
      return <ul>
        {csvFileUrl ?
          validURL ?
            <li><a href={csvFileUrl}>{this.props.content[this.props.lang].downloadChamberCsv}</a></li> :
            <li><a href="#" onClick={() => {
              this.props.setProjectsUrlInvalidDialog(true);
            }}>{this.props.content[this.props.lang].downloadChamberCsv}</a></li>
          : <span />}
        {csvFileUrlPipe ?
          validURL ? <span />: <span />
            /* To Activate when Pipes receive CSV
            <li><a href={csvFileUrlPipe}>{this.props.content[this.props.lang].downloadPipeCsv}</a></li> :
            <li><a href="#" onClick={() => {
              this.props.setProjectsUrlInvalidDialog(true);
            }}>{this.props.content[this.props.lang].downloadPipeCsv}</a></li>*/
          : <span />}
      </ul>;
    } else {
      return "N/A";
    }
  }

  formatStageStorageFileFile( project ) {
    const { processingStatus: status, stageStorageURL, isMultiBedProject, singleBedStageStorageURL } = project;
    const validURL = GeneralService.isAzureUrlValid( stageStorageURL);
    const isInternalUser = true; // Requested on Monday: https://imaginit.monday.com/boards/232436054/pulses/4297061164
    if (status === Project.PROCESSING_STATUS.success && isInternalUser) {
      if (!isMultiBedProject) {
        return <ul>
          {stageStorageURL ?
            validURL ?
              <li><a href={singleBedStageStorageURL}>{this.props.content[this.props.lang].downloadStageStorageXlsx}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadStageStorageXlsx}</a></li>
            : <span />}
        </ul>;
      } else {
        return "N/A"; /* We dont show link on multibed, it is by design*/
      }
    } else {
      return "N/A";
    }
  }


  formatProcessingResult( project ) {
    const { processingStatus: status, outputFileURL, outputFileURLPipe } = project;
    const validURL = GeneralService.isAzureUrlValid(
      outputFileURL ? outputFileURL : outputFileURLPipe
    );
    if (status === Project.PROCESSING_STATUS.success) {
      return <ul>
        {outputFileURL ?
          validURL ?
            <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadChamberResults}</a></li> :
            <li><a href="#" onClick={() => {
              this.props.setProjectsUrlInvalidDialog(true);
            }}>{this.props.content[this.props.lang].downloadChamberResults}</a></li>
          : <span />}
        {outputFileURLPipe ?
          validURL ?
            <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadPipeResults}</a></li> :
            <li><a href="#" onClick={() => {
              this.props.setProjectsUrlInvalidDialog(true);
            }}>{this.props.content[this.props.lang].downloadPipeResults}</a></li>
          : <span />}
      </ul>;
    } else {
      return "N/A";
    }
  }

  formatCreatedDate( project ) {
    const { createdDate } = project;
    return <span>{dayjs(createdDate).format("MM-DD-YYYY-hh:mm:ss-A")}</span>;
  }

  formatTranslatedProjectType( project ) {
    const { projectType } = project;
    return _.startCase(_.toLower(projectType));
  }

  formatEditedDate( project ) {
    const { editedDate } = project;
    if (editedDate) {
      return <span>{dayjs(editedDate).format("MM-DD-YYYY-hh:mm:ss-A")}</span>;
    } else {
      return this.props.content[this.props.lang].notEdited;
    }
  }

  expanderButton( project ) {
    if (project && project.subProjects.length > 0) {
      let icon = "pi  pi-angle-right";
      if (this.state && this.state.expandedRows && this.state.expandedRows[project.id]) icon = "pi  pi-angle-down";
      return <Button icon={icon}
                     className="p-button-rounded p-button-text icon_expander"
                     onClick={this.expandById.bind(this, project.id)} />;
    }
    return false;
  }

  async deleteAllRecord() {
    const record = this.state.selectedProject;
    try {

      if (!record.country) record.country = this.props.region.name;

      if (!record.region) record.region = this.props.region.id;

      if (!record.language) record.language = "to_delete";

      let project_instance = ProjectService.getNewProjectInstance(record);

      project_instance.active = false;
      await project_instance.persist(
        this.props.user.id,
        this.props.resourcesTokens.projects.tableToken
      );

      const ret = await MiniCADAPI_SEARCH.deleteProjectDocument({ project: project_instance });
      this.props.switchRefreshAdminProjects(true);
    } catch (e) {
      console.log(`ProjectsCrud.deleteAllRecord() ${e.message}`);
    }
    this.closeDialog();
  }

  setSelectionDetails = ( val ) => {
    if (val === null) {
      this.setState({ selectionDetails: "" });
      return;
    }
    const msg = `1 ${this.props.content[this.props.lang].itemSelected}: ${val.projectName}`;
    this.setState({ selectionDetails: msg });
  };

  onStatusChange( event, option ) {
    this.dt.filter(option.key, "processingStatus", "equals");
    this.setState({ selectedStatus: option.key });
  }

  onTypeChange( event, option ) {
    this.dt.filter(option.key, "translatedProjectType", "equals");
    this.setState({ selectedType: option.key });
  }

  statusItemTemplate( option ) {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  }

  reset() {
    this.setState({
      selectedStatus: null,
      selectedType: null,
      globalFilter: ""
    });
    this.dt.reset();
  }

  render() {
    const {
      lang,
      content,
      selectedUser
    } = this.props;
    const bomFileText = content[lang].bomFile;
    const csvFileText = content[lang].csvFile;
    const stageStorageFileText = content[lang].stageStorageFile;
    const resultText = content[lang].results;
    const pipeResultsText = content[lang].result;
    const pipeBomText = content[lang].bomFile;
    const pipeCsvText = content[lang].downloadPipeCsv;

    const styledHeader = ( data ) => {
      return <span style={{
        display: "flex",
        alignItems: "flex-end",
        marginRight: "5px"
      }}><i className={`ms-Icon ms-Icon--${data.iconName}`}
            style={{ fontSize: "13px", marginRight: "5px" }} /> {data.fieldName}</span>;
    };

    const resultBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.outputFileURL);
      const text = pipeResultsText;
      return data.outputFileURL && data.outputFileURL.length ?
        validURL ?
          ( <a href={data.outputFileURL}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const bomBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.bomFileUrl);
      const text = pipeBomText;
      return data.bomFileUrl && data.bomFileUrl.length ?
        validURL ?
          ( <a href={data.bomFileUrl}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const csvBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.csvFileUrl);
      const text = pipeCsvText;
      return data.csvFileUrl && data.csvFileUrl.length ?
        validURL ?
          ( <a href={data.csvFileUrl}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const stageStorageBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.stageStorageURL);
      const text =  stageStorageFileText;
      return data.stageStorageURL && data.stageStorageURL.length ?
        validURL ?
          ( <a href={data.stageStorageURL}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const csvBodyChamberTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.csvFileUrl);
      const text = data.projectType === "CHAMBER" ? csvFileText : pipeCsvText;
      return data.csvFileUrl && data.csvFileUrl.length ?
        validURL ?
          ( <a href={data.csvFileUrl}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const stageStorageBodyChamberTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.multiBedStageStorageURL);
      const text = stageStorageFileText;
      return data.multiBedStageStorageURL && data.multiBedStageStorageURL.length ?
        validURL ?
          ( <a href={data.multiBedStageStorageURL}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const rowExpansionTemplate = ( data ) => {
      return (
        ( data.subProjects.length > 0 ) ?
          data.projectType === "PIPE"
            ? ( <div className="expanded_subprojects">
              <DataTable value={data.subProjects} className={"expanded_projects"}>
                <Column field="projectName"
                        header={styledHeader({ iconName: "CRMReport", fieldName: "" })}
                        style={{
                          width: "400px"
                        }}
                />
                <Column field="bomFileURLPipe"
                        columnKey="bomFileURLPipe"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: bomFileText })}
                        body={bomBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
                {/*<Column field="csvFileURLPipe"
                        columnKey="csvFileURLPipe"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: csvFileText })}
                        body={csvBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />*/}
                <Column field="outputFileURLPipe"
                        columnKey="outputFileURLPipe"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: resultText })}
                        body={resultBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
              </DataTable>
            </div> )
            : ( <div className="expanded_subprojects">
              {/* Dataset for Multibed - Subprojects */}
              <DataTable value={data.subProjects} className={"expanded-projects"}>
                <Column field="projectName"
                        header={styledHeader({ iconName: "CRMReport", fieldName: "" })}
                        style={{
                          width: "400px"
                        }}
                />
               {/* <Column field="stageStorageURL"
                        columnKey="stageStorageURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: stageStorageFileText })}
                        body={stageStorageBodyChamberTempl}
                        style={{
                          width: "300px"
                        }}
                />*/}
                <Column field="bomFileURL"
                        columnKey="bomFileURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: bomFileText })}
                        body={bomBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
                {/*<Column field="csvFileURL"
                        columnKey="csvFileURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: csvFileText })}
                        body={csvBodyChamberTempl}
                        style={{
                          width: "300px"
                        }}
                />*/}
                <Column field="outputFileURL"
                        columnKey="outputFileURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: resultText })}
                        body={resultBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
              </DataTable>
            </div> )
          : null
      );
    };

    const promptDelete = () => {
      const project = this.state.selectedProject;
      this.setState({
        confirmCB: () => this.deleteAllRecord(),
        contentProps: {
          type: DialogType.normal,
          //title: content[lang].confirmProjectsDeletion,
          title: "Confirm deletion of selected project",
          subText: `The project "${project.projectName}" ${content[lang].willBeDeleted}`
        },
        hideDialog: false
      });
    };

    const statusFilter = <Dropdown
      placeholder="Select a Status"
      styles={
        {
          dropdownItemSelected: {
            color: "white",
            backgroundColor: "#0C92CD",
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          dropdownItem: {
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          width: "100px"
        }
      }
      readOnly={false}
      onChange={this.onStatusChange}
      selectedKey={this.state.selectedStatus ? this.state.selectedStatus : null}
      options={this.statuses} />;

    const typeFilter = <Dropdown
      placeholder="Select a Type"
      styles={
        {
          dropdownItemSelected: {
            color: "white",
            backgroundColor: "#0C92CD",
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          dropdownItem: {
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          width: "100px"
        }
      }
      readOnly={false}
      onChange={this.onTypeChange}
      selectedKey={this.state.selectedType ? this.state.selectedType : null}
      options={this.types} />;

    return (
      <div>
        {/*TITLE PANEL*/}
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row title-row">
            <div className="ms-Grid-col ms-sm12 ms-md10 ms-lg6">
              <p className="ms-fontSize-xl crud-title ms-fontColor-white ms-normalize">
                <Icon iconName="ActivateOrders" className="ms-IconExample" /> {content[lang].projectsBy}
                ({selectedUser.givenName || ""})
              </p>
            </div>
          </div>
        </div>
        {/*ACTIONS PANEL*/}
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row ms-bgColor-neutralLight">
            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 input-container">
              {/*<TextField label="Filter by name:" onChange={this.handleFilterByName}/>*/}
              <InputText type="search"
                         value={this.state.globalFilter}
                         onChange={( e ) => this.setState({ globalFilter: e.target.value })}
                         placeholder="Global projects search" className={"global-search-2"} />
              {
                ( () => {
                  return this.state && this.state.selectedProject && this.state.selectedProject !== "" ? <DefaultButton
                    disabled={false}
                    onClick={promptDelete}
                    allowDisabledFocus={true}
                    className={"delete-button"}
                    text={content[lang].deleteSelected}
                    data-automation-id="delete-selected"
                  /> : null;
                } )()
              }
              <span style={{ marginRight: "100px" }} />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md3 ms-lg2 input-container">
              {
                ( () => {
                  return this.state && this.state.selectedProject && this.state.selectedProject !== "" ? <PrimaryButton
                    data-automation-id="load-selected"
                    allowDisabledFocus={true}
                    disabled={false}
                    text={`${content[lang].load} '${this.state.selectedProject.projectName}'`}
                    onClick={() => this.getSingleRecord(this.state.selectedProject.id)}
                    className="load-selected"
                  /> : null;
                } )()
              }
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md3 ms-lg2 input-container">
              <p className={"selection-details"}><b>{this.state.selectionDetails}</b></p>
            </div>
          </div>
        </div>
        <DataTable
          ref={( el ) => this.dt = el}

          globalFilter={this.state.globalFilter}
          emptyMessage="No projects found."

          value={this.state.projects}
          selection={this.state.selectedProject}
          onSelectionChange={evt => {
            this.setState({ selectedProject: evt.value });
            this.setSelectionDetails(evt.value);
          }}
          onRowDoubleClick={( evt ) => this.getSingleRecord(evt.data.id)}

          paginator
          rows={10}
          currentPageReportTemplate="{first} / {last} of {totalRecords}"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
          // scrollable
          // scrollHeight="400px"

          expandedRows={this.state.expandedRows}
          onRowToggle={( evt ) => this.setState({ expandedRows: evt.data })}
          rowExpansionTemplate={rowExpansionTemplate}
          className="p-datatable-projects"
          dataKey="id"
          rowHover>
          <Column selectionMode="single" headerStyle={{ width: "3em" }} className={"forced_padding"} />
          <Column expander style={{ width: "3em" }}
                  body={this.expanderButton}
          />
          <Column field="projectName"
                  columnKey="projectName"
                  header={this.styledHeader({
                    iconName: "CRMReport",
                    fieldName: content[lang]["projectName"].replace(":", "")
                  })}
                  sortable
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="by name"
          />
          <Column field="city"
                  header={this.styledHeader({ iconName: "POI", fieldName: content[lang].city })}
                  sortable
                  filter
                  filterPlaceholder="by city"
          />
          <Column field="state"
                  header={this.styledHeader({ iconName: "POISolid", fieldName: content[lang].state })}
                  headerStyle={{
                    width: "200px"
                  }}
                  sortable
                  filter
                  filterPlaceholder="by state"
          />
          {/*<Column field="translatedProjectType"
                  columnKey="translatedProjectType"
                  header={this.styledHeader({
                    iconName: "BulletedList2",
                    fieldName: content[lang].productType.replace(":", "")
                  })}
                  headerStyle={{
                    width: "200px"
                  }}
                  sortable
                  filter
                  filterPlaceholder="by type"
                  filterElement={typeFilter}
          />*/}
          <Column field="processingStatus"
                  header={this.styledHeader({ iconName: "WorkItem", fieldName: content[lang].processingStatus })}
                  body={this.formatProcessingStatus}
                  sortable
                  filter
                  filterPlaceholder="by status"
                  filterElement={statusFilter}
          />
          <Column field="columnStageStorageFileUrl"
                  header={this.styledHeader({ iconName: "ZipFolder", fieldName: content[lang].stageStorageFile })}
                  body={this.formatStageStorageFileFile}
                  headerStyle={{
                    width: "300px"
                  }}
          />
          {/*<Column field="columnBomFileUrl"
                  header={this.styledHeader({ iconName: "ZipFolder", fieldName: content[lang].bomFile })}
                  body={this.formatBOOMFile}
          />*/}
          {/*<Column field="columnCsvFileUrl"
                  header={this.styledHeader({ iconName: "ZipFolder", fieldName: content[lang].csvFile })}
                  body={this.formatCSVFile}
          />*/}

          <Column field="columnResult"
                  columnKey="columnResult"
                  header={this.styledHeader({ iconName: "ZipFolder", fieldName: content[lang].result })}
                  body={this.formatProcessingResult}
          />
          <Column field="createdDate"
                  columnKey="columnCreatedDate"
                  header={this.styledHeader({ iconName: "Calendar", fieldName: content[lang].editedDate })}
                  body={this.formatEditedDate}
                  sortable
          />
          <Column field="editedDate"
                  columnKey="columnEditedDate"
                  header={this.styledHeader({ iconName: "Calendar", fieldName: content[lang].createdDate })}
                  body={this.formatCreatedDate}
                  sortable
          />

        </DataTable>
        <Dialog
          onDismiss={this.closeDialog}
          hidden={this.state.hideDialog}
          modalProps={this.state.modalProps}
          dialogContentProps={this.state.contentProps}
        >
          <DialogFooter>
            <PrimaryButton onClick={() => this.handleConfirm()} text={content[lang].confirm} />
            <DefaultButton onClick={() => this.closeDialog()}
                           text={content[lang].cancel}
                           className={"outline_grey_ads"} />
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lang: state.localization.lang,
    user: state.authentication.user,
    content: state.localization.content,
    iTokens: state.projectsAdmin.iTokens,
    projects: state.projectsAdmin.projects,
    projectInfo: state.project.projectInfo,
    selectedUser: state.projectsAdmin.selectedUser,
    resourcesTokens: state.authentication.resourcesTokens,
    regions: state.localization.regions,
    languages: state.localization.languages,
    multiBed: state.multiBed,
    showMultibedSaveWarning: state.projectsAdmin.showMultibedSaveWarning,
    region: state.localization.region,
    refreshAdminProjects: state.globals.refreshAdminProjects
  };
};

const mapDispatchToProps = {
  loginUser,
  logoutUser,
  setCurrentProject,
  restorePersistedState,
  toggleProjectsAdminModal,
  toggleAdminProjectsLoader,
  setDirtyStateForMultiBeds,
  loadingBed,
  setMultiBedOtherUserData,
  resetSystemParams,
  setActiveRegion,
  setActiveLanguage,
  clearMainManifoldsState,
  doubleTapRestorePersistedState,
  toggleProjectsCrudModal,
  loadingMultiBedProject,
  setSelectedBed,
  hideUnsavedChangesDialog,
  clearViewPort,
  setCurrentSubProject,
  restoreSubProjectPersistedState,
  showProjectsAdminMultibedWarning,
  switchRefreshAdminProjects,
  setProjectsUrlInvalidDialog
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectsDetailListComponent);



// WEBPACK FOOTER //
// ./src/components/ProjectsAdminCrud/ProjectsDetailListComponent.js